import React from 'react';
import classnames from 'classnames';
import { isSpaLink, stripHost } from 'tradera/utils/url';
import { useUrlLocalizer } from 'tradera/lang/translate';
import { getImageSizes, getWebpImage } from '../image-sizes';
import { trackContainerClick } from '../analytics';
import MediaItem from '../media/media-item';
import ALink from 'tradera/components/alink/alink';
import css from './pop-cat-item.module.scss';

export const PopCatGridItem = ({
    containerType,
    inSPA,
    item,
    itemCount,
    itemHeadersAsImageOverlay,
    videoEnabled,
    isGrid,
    ...props
}) => {
    const { alternativeText, image, webpageUrl, heading, trackingId, video } =
        item;
    const { toLocalizedUrl } = useUrlLocalizer();

    const imageSizes = getImageSizes(itemCount, image, containerType, isGrid);
    const webpImage = getWebpImage(itemCount, image, containerType, isGrid);
    const url = stripHost(toLocalizedUrl(webpageUrl ?? ''));

    return (
        <ALink
            useLink={inSPA && isSpaLink(url)}
            aria-label={alternativeText || heading}
            href={url}
            onClick={() => trackContainerClick(containerType, trackingId)}
            className={css.wrapper}
            {...props}>
            <div
                className={classnames(css.media, css.landscape, 'bg-gray-300')}>
                <MediaItem
                    alternativeText={alternativeText}
                    heading={heading}
                    imageSizes={imageSizes}
                    image={image}
                    video={videoEnabled ? video : null}
                    webpImage={webpImage}
                />
                {itemHeadersAsImageOverlay && heading && (
                    <div className={css.gridContent}>
                        <span
                            className={`${css.gridContentText} d-flex m-auto px-1 text-center font-weight-bold text-white text-styled`}>
                            {heading}
                        </span>
                    </div>
                )}
            </div>
        </ALink>
    );
};
